export const BET_SLIP_STORAGE_KEYS = {
    expiration: 'tempBetSlipExpiration',
    single: 'tempBetSlipSingle',
    outright: 'tempOutrightBetSlip',
    dynamicMarket: 'tempDynamicBetSlipV2',
    mixParlay: 'tempBetSlipMixParlay',
    betBuilder: 'tempBetSlipBetBuilder',
    singleMode: 'tempBetSlipSingleModeV2',
    betSlipType: 'betSlipType',
    betSlipState: 'betSlipState',
    lastBetSlipType: 'lastBetSlipType',
    lastBetSlipState: 'lastBetSlipState',
} as const;

const PREVIOUS_VERSION_STORAGE_KEYS = [
    'tempDynamicBetSlip',
    'tempBetSlipSingleMode',
];

export const betSlipStorageKeysToClear = [
    ...Object.values(BET_SLIP_STORAGE_KEYS),
    ...PREVIOUS_VERSION_STORAGE_KEYS,
];
